import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import jpActions from "../../../actions/jpActions";
import { getJobPlans, isFetching } from "../../../reducers";
import { DataTypes } from "../../../constants";
import BlankCard from "../../Common/Card/BlankCard";
import JobPlanErrorCard from "./JobPlan/JobPlanErrorCard";
import JobPlanCard from "./JobPlan/JobPlanCard";
import ThisTheme from "../../../themes/JPTheme";

const appCode = "P-JP";

const JPWidget = () => {
    const dispatch = useDispatch();
    const jobPlans = useSelector(getJobPlans);
    const fetching = useSelector((state) =>
        isFetching(state, DataTypes.JP_JOBPLAN)
    );

    useEffect(() => {
        dispatch(jpActions.getJobPlans(appCode));
    }, [dispatch]);

    if (fetching) return <BlankCard />;

    const currentJobPlan = jobPlans.reduce(
        (current, jobPlan) => (jobPlan.status === "draft" ? jobPlan : current),
        null
    );

    return currentJobPlan ? (
        <JobPlanCard jobPlan={currentJobPlan} theme={ThisTheme} />
    ) : (
        <JobPlanErrorCard error="No data available" message="" />
    );
};

export default JPWidget;
